import { RequestsApi } from '../RequestsApi';

class CatalogApi extends RequestsApi {
    async getAdvisorsList(categories = '', page = 1) {
        return await this.request(`/advisor${categories}&page=${page}`, 'get');
    }

    async getActivitiesList(categories = '', page = 1) {
        return await this.request(`/activity${categories}&page=${page}`, 'get');
    }

    async getActivity(activityId) {
        return await this.request(`/activity/${activityId}/landing`, 'get');
    }

    async getAdvisorById(id) {
        return await this.request(`/advisor/id/${id}`, 'get');
    }

    async getAdvisorByAlias(alias) {
        return await this.request(`/advisor/alias/${alias}`, 'get');
    }

    async getAdvisorsCategories() {
        return await this.request('/category', 'get');
    }

    async getAdvisorDetails(advisorAlias) {
        return await this.request(`/advisor/alias/${advisorAlias}/landing`, 'get');
    }

    // HORO-10426: the full curated question bank for the homepage typeahead.
    // Fetched once and cached client-side; filtering + randomization happen
    // locally (no per-keystroke API call). Returns { suggestions: string[] }.
    async getQuestionBank() {
        return await this.request('/suggestions?all=1', 'get');
    }
}

export default new CatalogApi();
